import { FC } from 'react';
import { Base } from '../base';

type Props = HasClassName<{
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
}>;

export const Layout: FC<Props> = ({ className, ...style }) => (
  <Base className={className} style={style} />
);
